<template>
    <div class="col col-12 text-center">
        <div class="row justify-content-center ">
            <div class="col col-11 mail_box">
                <h2>Díky!</h2>
                <p>Dejte si jedno &nbsp;<img src="@/assets/img/beer_white.png" class="rating_icon"/>&nbsp; na nás!</p>
                <div class="row">
                    <div class="col-9">
                        <b-form-input id="mail_input" v-model="email" type="email" />
                    </div>
                    <div class="col-3 text-left">
                        <b-button id="mail_button" variant="light" size="sm" to="thankyou"><img src="@/assets/img/send.png"/></b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                email: null
            }
        },
        name: 'mail',
    }
</script>

<style scoped lang="scss">
    @import 'src/scss/custom';

    .mail_box {
        background-color: $primary;
        color: white;
        margin-top: 60px;
        border-radius: 0.5rem;
        padding: 20px;
        padding-top: 50px;
        padding-bottom: 40px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    }

    h2 {
        font-size: 32px;
        margin-bottom: 30px;
    }

    #mail_input {
        border-radius: 0.5rem;
    }

    #mail_button {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
    }
</style>
